import USBaseRegulation from '../us_base_regulation';
import { REGULATION_CODE_TYPES } from '../../../regulation_const';
import { CGP_ERROR_CODES } from '../../../../../exceptions/cgp_error_codes';

export default class DelawareRegulation extends USBaseRegulation {

    static CLASS = 'DelawareRegulation';


    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.DELAWARE;
    }
    getErrorMessage(errorCode) {
        errorCode = errorCode.toString();
        if(errorCode === CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY.toString()) {
            return this.serviceFactory.languageService().translation(CGP_ERROR_CODES.TIME_LIMIT_REACHED_DAILY.toString());
        }

        return super.getErrorMessage(errorCode);
    }

    isAnonymousPlayAllowed(): boolean {
        return !this.serviceFactory.oAuth2Service().isAuthorized();
    }
}
